"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const icon_1 = __importDefault(require("../../components/icon/icon"));
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const schedulesList_1 = __importDefault(require("../../components/schedules/schedulesList"));
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const eventConstants_1 = require("../../constants/eventConstants");
const screenConstants_1 = require("../../constants/screenConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const SchedulesSlice_1 = require("./SchedulesSlice");
const scheduleSlice_1 = require("./scheduleSlice");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const OfficerSchedules = () => {
    const dispatch = useAppDispatch_1.default();
    const navigation = native_1.useNavigation();
    const { schedules, loadingStatus } = useAppSelector_1.default((state) => ({
        schedules: state.schedules.schedules,
        loadingStatus: state.schedules.loadingStatus,
    }));
    const navigator = native_1.useNavigation();
    const isDesktop = useWebDesktopDesign_1.default();
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const route = native_1.useRoute();
    const officerId = route.params.officer_id;
    const title = schedules.length > 0 ? `${schedules[0].credit_officer_name}'s Schedules` : 'Officer Schedules';
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(scheduleSlice_1.resetScheduleState());
        dispatch(SchedulesSlice_1.getOfficerSchedules({ officerId, page: 1 }));
    }, []));
    const getSchedulesPage = (page) => {
        dispatch(SchedulesSlice_1.resetSchedulesState());
        dispatch(SchedulesSlice_1.getOfficerSchedules({ officerId, page }));
    };
    const navigateToSchedule = ({ scheduleId }) => {
        navigation.push(screenConstants_1.SCHEDULE_SCREEN, { schedule_id: scheduleId });
    };
    let content = react_1.default.createElement(react_1.default.Fragment, null);
    if (loadingStatus === typesConstants_1.PENDING_STATUS) {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    else if (loadingStatus === typesConstants_1.SUCCEEDED_STATUS) {
        if (schedules.length === 0) {
            content = (react_1.default.createElement(messageComponent_1.default, { message: "This officer has no completed schedules at the moment.", color: colors_1.default.GREEN, icon: free_solid_svg_icons_1.faCheckCircle }));
        }
        else {
            content = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
                react_1.default.createElement(schedulesList_1.default, { schedules: schedules, onRowPress: navigateToSchedule, onPageChange: getSchedulesPage })));
        }
    }
    else {
        content = react_1.default.createElement(messageComponent_1.default, { message: "An error occurred.", color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle });
    }
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: containerStyle },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: title })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(pressable_1.default, { onPress: () => navigator.navigate(screenConstants_1.OFFICERS_METRICS_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_HOME_BUTTON },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, `Metrics `)))))),
            react_1.default.createElement(react_native_1.View, null, content))));
};
exports.default = OfficerSchedules;
